<template>
  <v-combobox
    ref="combo"
    :model-value="uiValue"
    :items="floorOptions"
    item-title="name"
    item-value="value"
    return-object
    :custom-value="true"
    variant="underlined"
    density="compact"
    hide-details
    @update:modelValue="onUIChange"
    @update:search="onSearchUpdate"
    @blur="onBlur"
  />
</template>

<script>
import { normalizeFloorValue } from "@/utils/floorUtils";

export default {
  name: "FloorSelect",
  props: {
    modelValue: {
      type: [Number, String, Object, null],
      default: null,
    },
    floorOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      draft: null,
      searchText: "",
    };
  },
  computed: {
    uiValue() {
      if (this.draft !== null && this.draft !== undefined) {
        return this.draft;
      }
      const normalized = normalizeFloorValue(this.modelValue);
      if (!normalized) return "";
      const byValue = this.floorOptions.find(
        f => normalizeFloorValue(f.value) === normalized
      );
      return byValue || normalized;
    },
  },
  methods: {
    toBackend(v) {
      if (v == null || v === "") return null;
      if (typeof v === "object") {
        return normalizeFloorValue(
          v.value ?? v.floor ?? v.id ?? v.raw ?? v.label ?? ""
        );
      }
      const raw = normalizeFloorValue(v);
      if (!raw) return null;
      const byName = this.floorOptions.find(
        f => String(f.name).toLowerCase() === raw.toLowerCase()
      );
      if (byName) return normalizeFloorValue(byName.value);
      return raw;
    },
    onUIChange(v) {
      this.draft = v == null ? "" : v;
      if (v == null || v === "") {
        this.$emit("update:modelValue", null);
        return;
      }
      if (v && typeof v === "object") {
        this.$emit("update:modelValue", this.toBackend(v));
      }
    },
    onSearchUpdate(s) {
      this.searchText = s ?? "";
    },
    valueToCommitOnBlur() {
      if (this.draft !== null && this.draft !== undefined) return this.draft;
      const fromSearch = String(this.searchText ?? "").trim();
      if (fromSearch) return fromSearch;
      const input = this.$refs.combo?.$el?.querySelector?.("input");
      const raw = input?.value != null ? String(input.value).trim() : "";
      return raw || null;
    },
    onBlur() {
      this.$emit("update:modelValue", this.toBackend(this.valueToCommitOnBlur()));
      this.draft = null;
      this.searchText = "";
    },
  },
};
</script>
